import { SET_GLOBAL_VALUE } from "../actions/commonActions";

const initialState = {
    globalValue: '',
};
  
export const globalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GLOBAL_VALUE:
        return {
            ...state,
            globalValue: action.payload,
        };
        default:
        return state;
    }
};